/** 选中框：8 个缩放手柄 + 旋转手柄。手柄尺寸按 zoom 反向缩放，视觉恒定。 */
import type { CSSProperties, PointerEvent as RPointerEvent } from 'react';

export type HandleDir = 'n' | 's' | 'e' | 'w' | 'ne' | 'nw' | 'se' | 'sw';
export const HANDLES: HandleDir[] = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'];

const CURSORS: Record<HandleDir, string> = {
  n: 'ns-resize', s: 'ns-resize', e: 'ew-resize', w: 'ew-resize',
  ne: 'nesw-resize', sw: 'nesw-resize', nw: 'nwse-resize', se: 'nwse-resize',
};

function handlePos(dir: HandleDir): CSSProperties {
  const s: CSSProperties = {};
  if (dir.includes('n')) s.top = 0; else if (dir.includes('s')) s.top = '100%'; else s.top = '50%';
  if (dir.includes('w')) s.left = 0; else if (dir.includes('e')) s.left = '100%'; else s.left = '50%';
  return s;
}

interface Props {
  zoom: number;
  resizable: boolean;
  rotatable: boolean;
  locked: boolean;
  /** 多选时只画外框，不给手柄 */
  handlesOnly?: boolean;
  onResizeStart(dir: HandleDir, e: RPointerEvent): void;
  onRotateStart(e: RPointerEvent): void;
}

export function LayerFrame({ zoom, resizable, rotatable, locked, handlesOnly, onResizeStart, onRotateStart }: Props) {
  const size = 8 / zoom;
  const border = 1 / zoom;
  const color = locked ? '#faad14' : '#1677ff';
  return (
    <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', outline: `${border}px solid ${color}`, outlineOffset: -border }}>
      {!locked && !handlesOnly && resizable && HANDLES.map((dir) => (
        <div
          key={dir}
          onPointerDown={(e) => { e.stopPropagation(); onResizeStart(dir, e); }}
          style={{
            position: 'absolute', ...handlePos(dir), width: size, height: size,
            marginLeft: -size / 2, marginTop: -size / 2,
            background: '#fff', border: `${border}px solid ${color}`, borderRadius: 1 / zoom,
            cursor: CURSORS[dir], pointerEvents: 'auto', boxSizing: 'border-box',
          }}
        />
      ))}
      {!locked && !handlesOnly && rotatable && (
        <div
          onPointerDown={(e) => { e.stopPropagation(); onRotateStart(e); }}
          title="拖动旋转"
          style={{
            position: 'absolute', left: '50%', top: -20 / zoom, width: size * 1.4, height: size * 1.4,
            marginLeft: -size * 0.7, borderRadius: '50%', background: '#fff', border: `${border}px solid ${color}`,
            cursor: 'grab', pointerEvents: 'auto', boxSizing: 'border-box',
          }}
        />
      )}
    </div>
  );
}
